import { Component, Inject, SimpleChanges } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpinnerComponent } from 'src/app/shared/component/spinner/spinner.component';
import { passwordStrengthValidator } from 'src/app/shared/custom-validator/password-validator';
import { noWhitespaceValidator } from 'src/app/shared/custom-validator/white-space-validator';
import { ChangePasswordComponent } from '../../manage-profile/change-password/change-password.component';
import { ManageProfileService } from '../../manage-profile/manage-profile.service';
import { LoginService } from '../service/login.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
 hideNewPwd: boolean = true;
  hideConfirmPwd: boolean = true;
  changePassword = this._formBuilder.group({
    newPassword: ['',         [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          noWhitespaceValidator(),passwordStrengthValidator()
        ],],
    confirmPassword: ['',         [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          noWhitespaceValidator(),passwordStrengthValidator()
        ],],
  });
  passwordMatch:boolean = true
  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {

  }
  cancelForm() {
    this.dialogRef.close()
  }
  updatePwd() {
    if(this.passwordMatch){
      let apiData;
      const updateSpinnerRef = this.dialog.open(SpinnerComponent, {
        disableClose: true,
        panelClass: 'transparent-dialog',
      });
      apiData = {
          email:this.loginService.email,
          newPassword: this.changePassword.value.confirmPassword
        };
        this.loginService.resetPassword(apiData).subscribe({
          next: (data: any) => {
            if (data.status === 200) {
              this.dialogRef.close('success');
              updateSpinnerRef.close();
            }
          },
          error: (error: any) => {
            updateSpinnerRef.close();
          },
        });
    }
  }

  togglePasswordVisibility(field: string) {
    if (field === 'hideNewPwd') {
      this.hideNewPwd = !this.hideNewPwd;
    } else {
      this.hideConfirmPwd = !this.hideConfirmPwd;
    }
  }

  passwordMatchValidator() {
    const newPassword = this.changePassword.value.newPassword;
    const confirmNewPassword = this.changePassword.value.confirmPassword;
    if(newPassword && confirmNewPassword){
      if (newPassword !== confirmNewPassword) {
        this.passwordMatch =  false;
      }
      else{
        this.passwordMatch = true
      }
    }
  }

  showLogin(type:string){
      this.dialogRef.close({status:'success', type:type});
  }
}
